import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8 min-h-screen flex flex-col max-w-3xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold mb-6" }, "뉴스 선택하기", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex-grow flex items-center justify-center"
}
const _hoisted_4 = { class: "text-center -mt-16 md:-mt-24" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "뉴스 기사를 불러오는 중...", -1)
const _hoisted_6 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col h-[calc(100vh-200px)]"
}
const _hoisted_8 = { class: "flex justify-between items-center mb-5" }
const _hoisted_9 = { class: "text-sm text-gray-600" }
const _hoisted_10 = { class: "flex-grow overflow-y-auto mb-4" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-4" }

import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useArticleStore } from "../stores/articleStore";
import LinkPreview from "../components/LinkPreview.vue";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Paginator from "primevue/paginator";
import type { NewsItem } from "../types";
import { MAX_NEWS_ITEMS } from "../../backend/config/newsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsSelectionPage',
  setup(__props) {

const router = useRouter();
const articleStore = useArticleStore();
const newsItems = ref<NewsItem[]>([]);
const selectedItems = ref<NewsItem[]>([]);
const isLoading = ref(true);
const error = ref("");
const first = ref(0);

const paginatedNewsItems = computed(() => {
  const start = first.value;
  const end = start + 5;
  return newsItems.value.slice(start, end);
});

const isSelected = (item: NewsItem) =>
  selectedItems.value.some((i) => i.link === item.link);

const toggleSelection = (item: NewsItem) => {
  const index = selectedItems.value.findIndex((i) => i.link === item.link);
  if (index === -1) {
    if (selectedItems.value.length < MAX_NEWS_ITEMS) {
      selectedItems.value.push(item);
    }
  } else {
    selectedItems.value.splice(index, 1);
  }
};

const generatePost = () => {
  articleStore.setSelectedNewsItems(selectedItems.value);
  router.push("/result");
};

const fetchNewsItems = async () => {
  try {
    newsItems.value = await articleStore.searchNews();
  } catch (e) {
    error.value = "뉴스 기사를 불러오는데 실패했습니다. 다시 시도해 주세요.";
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchNewsItems);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(ProgressSpinner)),
            _hoisted_5
          ])
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(selectedItems.value.length) + "/" + _toDisplayString(_unref(MAX_NEWS_ITEMS)) + " 선택됨 ", 1),
              _createVNode(_unref(Button), {
                label: "포스트 생성하기",
                icon: "pi pi-file-edit",
                onClick: generatePost,
                disabled: selectedItems.value.length === 0
              }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedNewsItems.value, (item) => {
                  return (_openBlock(), _createBlock(LinkPreview, {
                    key: item.link,
                    "news-item": item,
                    selected: isSelected(item),
                    onToggleSelection: ($event: any) => (toggleSelection(item))
                  }, null, 8, ["news-item", "selected", "onToggleSelection"]))
                }), 128))
              ])
            ]),
            _createVNode(_unref(Paginator), {
              first: first.value,
              "onUpdate:first": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
              rows: 5,
              "total-records": newsItems.value.length,
              template: "PrevPageLink PageLinks NextPageLink"
            }, null, 8, ["first", "total-records"])
          ]))
  ]))
}
}

})